<template>
  <div>
    <b-row no-gutters>
      <b-col lg="12" xl="8" xxl="8">
        <card class="data-card mb-4" :show-footer-line="true">
          <b-overlay
            variant="light"
            opacity="0.88"
            :show="loading"
            rounded="sm"
          >
            <b-row no-gutters>
              <b-col no-gutters lg="12" sm="12" class="right-section">
                <h2 v-if="title" class="title">
                  {{ title }}
                </h2>
                <slot></slot>
              </b-col>
            </b-row>
            <template #overlay>
              <div class="text-center">
                <b-col md="6" class="mb-3">
                  <b-icon
                    icon="arrow-clockwise"
                    animation="spin"
                    font-scale="4"
                  ></b-icon>
                </b-col>
                <p id="cancel-label">در حال بارگزاری</p>
              </div>
            </template>
          </b-overlay>
        </card>
      </b-col>
      <b-col v-if="guidanceItems || planItems">
        <b-row v-if="guidanceItems">
          <b-col>
            <card>
              <b-col lg="12" sm="0" class="left-section">
                <h2 v-if="guidanceItemsTitle" class="title">
                  {{ guidanceItemsTitle }}
                </h2>
                <p>
                  {{ guidanceItems }}
                </p>
              </b-col>
            </card>
          </b-col>
        </b-row>

        <b-row v-if="planItems" class="mt-4 mb-3">
          <b-col>
            <card>
              <b-col lg="12" sm="0">
                <h2 class="title mt-3">امکانات کاربر</h2>
                <hr class="seperator mt-3" />
                <b-list-group class="pl-0 pr-0" flush>
                  <b-list-group-item
                    v-for="(item, index) in planItems.items"
                    :key="index"
                    class="pl-0 pr-0 pt-3 pb-2"
                  >
                    <b-row no-gutters>
                      <b-col cols="1">
                        <span class="material-icons-outlined text-green">
                          check_circle
                        </span>
                      </b-col>
                      <b-col> {{ item }}</b-col>
                    </b-row>
                  </b-list-group-item>
                </b-list-group>
              </b-col>
            </card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Card from "./Card.vue";

export default {
  name: "data-card",
  components: {
    Card,
  },

  data() {
    return {
      userBoxArrow: "chevron-down",
    };
  },
  props: {
    type: {
      type: String,
      default: "primary",
    },
    guidanceItems: {
      type: String,
    },
    planItems: {
      type: Object,
    },
    loading: {
      type: Boolean,
    },
    guidanceItemsTitle: {
      type: String,
    },
    data: {
      type: Object,
    },
    icon: String,
    title: String,
  },

  mounted() {
    this.toggle_icon();
  },

  methods: {
    toggle_icon() {
      this.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
        if (isJustShown == true) {
          this.userBoxArrow = "chevron-up";
        } else {
          this.userBoxArrow = "chevron-down";
        }
      });
    },
  },
};
</script>
<style lang="scss">
.data-card {
  border-radius: 8px;

  .text-green {
    color: #7acf6e;
  }

  text-align: right;
  direction: rtl;

  .right-section {
    // @media (min-width: 992px) {
    //   padding: 0px 16px;
    // }
    // @media (max-width: 991px) {
    //   padding: 0px 16px;
    // }

    // .group-input {
    //   direction: ltr;
    //   .input-group-text {
    //     border: solid 1px rgba(33, 33, 33, 0.12);
    //     background-color: rgba(33, 33, 33, 0.04);
    //     border-right: 1px solid rgba(33, 33, 33, 0.12);
    //   }
    //   input {
    //     direction: rtl;
    //     border-left: 1px solid rgba(33, 33, 33, 0.12);
    //   }
    // }

    .title {
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: right;
      color: #212121;
      margin-bottom: 32px;
    }

    .form-label {
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
    }

    .row-form {
      margin-top: 16px;
    }

    // .IZ-select * {
    //   font-family: Shabnam !important;
    //   //   padding: 10px 16px !important;
    //   padding: 0;
    // }

    // .select_wrap {
    //   width: 100%;
    //   border: solid 1px rgba(33, 33, 33, 0.12);
    //   //   background-color: rgba(33, 33, 33, 0.04);
    //   border-radius: 8px;

    //   .IZ-select__input {
    //     box-shadow: none;
    //     border: solid 1px rgba(33, 33, 33, 0.12);
    //     background-color: rgba(33, 33, 33, 0.04);
    //     height: 42px;
    //     padding-right: 16px;
    //     // padding: 0;
    //   }
    // }
  }

  .left-section {
    padding: 16px 16px 16px 16px;
    border-right: 1px solid #e4e4e4;

    .title {
      font-size: 16px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: right;
      color: #212121;
    }

    ul {
      padding-right: 0;
      list-style: none;
      line-height: 32px;
      text-align: right;
      direction: rtl;
    }

    .info-card-body ul {
      text-align: right;
      list-style: none;
      margin-right: 15px;
    }

    ul li::before {
      content: "\2022";
      color: #2a6ae3;
      font-weight: 700;
      display: inline-block;
      width: 20px;
      padding: 0;
      margin-right: -1em;
    }

    ul li::before {
      content: "\2022";
      color: #2a6ae3;
      font-weight: 700;
      display: inline-block;
      width: 20px;
      padding: 0;
      margin-right: -1em;
    }
  }

  @media (min-width: 992px) {
    .info-section {
      display: none;
    }
  }

  @media (max-width: 991px) {
    .info-section {
      margin-top: 16px;

      header {
        background-color: #fff;

        .more-info-header-button {
          background-color: #ffffff;
          text-align: right;
          box-shadow: none;
          border-bottom: 1px solid rgba(33, 33, 33, 0.12);
          padding: 16px;
          font-size: 16px;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: normal;
          text-align: right;
          color: #212121;
        }

        .bi-chevron-down {
          border: none;
          padding: 0;
          width: 16px;
          height: 16px;
          line-height: 3;
          position: absolute;
          left: 16px;
          color: #757575;
          margin-top: 3px;
        }
      }

      .card-header {
        border-radius: 0;
        padding: 0 !important;
      }

      .card-body {
        padding: 16px !important;
        padding-right: 36px !important;

        ul {
          padding-right: 0;
          list-style: none;
          line-height: 32px;
          text-align: right;
          direction: rtl;
        }

        .info-card-body ul {
          text-align: right;
          list-style: none;
          margin-right: 15px;
        }

        ul li::before {
          content: "\2022";
          color: #2a6ae3;
          font-weight: 700;
          display: inline-block;
          width: 20px;
          padding: 0;
          margin-right: -1em;
        }

        ul li::before {
          content: "\2022";
          color: #2a6ae3;
          font-weight: 700;
          display: inline-block;
          width: 20px;
          padding: 0;
          margin-right: -1em;
        }
      }
    }
  }
}
</style>
